import { CloudSyncProvider } from '@wwf/sdk';

export const PROVIDER_LABELS: Record<CloudSyncProvider, string> = {
    GOOGLE_DRIVE: 'Google Drive',
    ONEDRIVE: 'OneDrive',
};

export const PROVIDER_DESCRIPTIONS: Record<CloudSyncProvider, string> = {
    GOOGLE_DRIVE: 'Sync documents from shared Google Drive folders.',
    ONEDRIVE: 'Sync documents from OneDrive or SharePoint libraries.',
};

export function isActiveConnection(
    connection: { status: string } | null | undefined
): boolean {
    return (
        connection?.status === 'CONNECTED' ||
        connection?.status === 'NEEDS_RECONNECT'
    );
}
